export class EstatusCreditoModel {
    idEstatusCredito: number;
    clave: string;
    descripcion: string;
}